import { useContext } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";

function ReviewsPage(props: any) {
  const { filters, formDefaultValues, formWidgets, config } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues, formWidgets, config);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction, formWidgets, config);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);


  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getConfig({
    initializeFunction, // We pass the function to initialize a new element (used in the create button)
    indexFunction, // We pass the function to index the table
    getFunction, // We pass the function to get an element (used in the edit button)
    prepareRemoveFunction,
    /**newActionsTableConfig**/
  });
  setTableConfig(tableConfig);

  return (
    <div className="ReviewsPage">
      <Card>
        <Card.Header className="bg-white">
          <div className="card-header-actions">
            <BeelditTableHeaderActions actions={tableConfig.actions} />
          </div>
        </Card.Header>

        <Card.Body>
          {listActionTemplate}
          {createActionTemplate}
          {editActionTemplate}
          {removeActionTemplate}
          {/* newTemplateActions */}
        </Card.Body>
      </Card>
    </div>
  );
}

export default ReviewsPage;
